import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";
import { services } from "../services/notificationService";

let params;

function init() {
    $(document).on("click", "#deleteRegionbtn", function() {
        const $deleteRegionBtn = $(this);
        $deleteRegionBtn.prop("disabled", true);
        
        const personRegionId = $(this).closest("tr")
            .find("#personRegionId")
            .text();
        const container = $("#regions");
        params = {
            "url": "/api/region/deleteregion/" + personRegionId
        };
        dataaccess.post(params).done(function(result) {
            container.html(result);
            $deleteRegionBtn.prop("disabled", false);
        });
    });

    $(document).on("click", "#updateRegionbtn", function() {
        const regionId = $(this).closest("tr").find("#updateRegionSelect").val();
        const personId = $("#personId").val();
        const personRegionId = $(this).closest("tr")
            .find("#personRegionId")
            .text();
        const container = $("#regions");

        const link = {
            "url": "/api/region/personregionexists/" + personId + "/" + regionId
        };

        dataaccess.get(link).done(function(results) {
            if (!results) {
                params = {
                    "url": "/api/region/editregion/" + regionId + "/" + personRegionId
                };
                dataaccess.post(params).done(function(result) {
                    container.html(result);
                });
            } else {
                services.notificationService.error("This region has already been assigned.");
            }
        });
    });

    $(document).on("click", "#addPersonRegionbtn", function() {
        $("#addRegionSelect").val("");
    });
}

export const regionTable = {
    init: init
};